import {GET_ALL,INSERT} from '../constants/actionTypes';


export default  (homePost=[],action) => {
    switch (action.type) {
        case GET_ALL:
                return action.payload;
        case INSERT :
            return [...homePost,action.payload];
    
        default:
            return homePost;
    }
};